// Copyright 2017 Sorama B.V.

export abstract class AsyncExtensions {
    /**
     * Returns a promise that returns almost immediately
     */
    public static immediatePromise(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            window.setTimeout(() => {
                resolve();
            }, 0);
        });
    }
}
